import { render, staticRenderFns } from "./ListNotificacionEnviadaPage.vue?vue&type=template&id=eafacc84"
import script from "./ListNotificacionEnviadaPage.vue?vue&type=script&lang=js"
export * from "./ListNotificacionEnviadaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports